import m from "../../geodata/es2015/stPierreMiquelonHigh";
window.am4geodata_stPierreMiquelonHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/stPierreMiquelonHigh.js
// module id = null
// module chunks = 